export default "__VITE_ASSET__BOATABTw__"